import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  GetCookie,
  toast,
  Switch,
} from "../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index";
import { IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  useAddFooterLogoMutation,
  useGetScreenConfigsMutation,
  useUpdateScreenConfigsMutation,
  useDeleteLogoMutation,
} from "../../Redux/service/AllEmpData";
import "react-toastify/dist/ReactToastify.css";

export default function LogoContent({ currentScreen }) {

  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [showLogoSettings, setShowLogoSettings] = useState(false);
  const [logoBgColor, setLogoBgColor] = useState("#ffffff");
  const [addLogo] = useAddFooterLogoMutation();
  const [getConfigsData] = useGetScreenConfigsMutation();
  const [updateScreenConfigs] = useUpdateScreenConfigsMutation();
  const [deleteLogo] = useDeleteLogoMutation();

  useEffect(() => {
    const fetchExistingLogo = async () => {
      const screenId = currentScreen?.ser_screen_id;
      if (!screenId) return;

      try {
        const formData = new FormData();
        formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
        formData.append("security_token", await GetCookie("es_token"));
        formData.append("ser_screen_id", screenId);

        const res = await getConfigsData(formData).unwrap();

        if (res.connection === "true" && res.status === "true") {
          const footer = res.data?.footer;

          if (footer?.logo_configs?.url)
            setLogoPreview(footer.logo_configs.url);

          if (footer?.logo_configs?.background)
            setLogoBgColor(footer.logo_configs.background);
        }
      } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
    };

    fetchExistingLogo();
  }, [currentScreen]);


  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));
  };

  // const handleRemoveLogo = () => {

  //   setLogoFile(null);
  //   setLogoPreview(null);
  // };
  const handleRemoveLogo = async () => {
    try {
      const formData = new FormData();
      formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
      formData.append("security_token", await GetCookie("es_token"));

      const response = await deleteLogo(formData).unwrap();

      if (response?.status === "true") {
        toast.success("Logo removed successfully!");
        setLogoFile(null);
        setLogoPreview(null);
      } else {
        toast.error(response?.message || "Failed to remove logo");
      }

    } catch (error) {
      console.error(error);
      toast.error(error?.status || "Something went wrong");
    }
  };

  const handleSaveLogo = async () => {
    if (!logoFile) return;

    const formData = new FormData();
    formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
    formData.append("security_token", await GetCookie("es_token"));
    formData.append("upload_type", "File");
    formData.append("logoFile", logoFile);
    // formData.append("screenId", currentScreen.ser_screen_id);

    try {
      const response = await addLogo(formData).unwrap();
      toast.success("Logo uploaded successfully!");

      if (response?.data?.footer?.logo_configs?.url)
        setLogoPreview(response.data.footer.logo_configs.url);

      setLogoFile(null);
    } catch (error) {
          console.error(error);
          toast.error(error.status);
          }
  };

  const handleSaveBgColor = async () => {
    try {
      const formData = new FormData();
      formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
      formData.append("security_token", await GetCookie("es_token"));
      formData.append("ser_screen_id", currentScreen.ser_screen_id);

      formData.append(
        "configuration",
        JSON.stringify({
          footer: { logo_configs: { background: logoBgColor } }
        })
      );

      const res = await updateScreenConfigs(formData).unwrap();

      if (res.connection === "true" && res.status === "true")
        toast.success("Background color updated!");
      else
        toast.error("Failed to update color");

    } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
  };
  return (
    <>
      {/* MAIN CARD */}
      <Box sx={{ flexGrow: 1 }}>
        <Grid container className="bg bg-white py-4 px-4 pb-5" sx={{ borderRadius: "16px" }}>

          <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h5 style={{ color: "grey" }}><b>Logo Settings</b></h5>

            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ fontSize: "13px", color: "#666" }}>Settings</span>
              <Switch
                size="small"
                checked={showLogoSettings}
                onChange={(e) => setShowLogoSettings(e.target.checked)}
              />
            </div>
          </Box>

          {/* LOGO */}
          <Grid item xs={12} sx={{ mt: 3 }}>
            {!logoPreview ? (
              <Button variant="contained" component="label">
                Upload Logo
                <input type="file" hidden accept="image/*" onChange={handleLogoChange} />
              </Button>
            ) : (
              <Box
                sx={{
                  position: "relative",
                  display: "inline-block",
                  backgroundColor: logoBgColor,
                  padding: "10px",
                  borderRadius: "10px"
                }}
              >
                <img
                  src={logoPreview}
                  alt="Logo Preview"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />

                <IconButton
                  onClick={handleRemoveLogo}
                  sx={{
                    position: "absolute",
                    top: -10,
                    right: -10,
                    backgroundColor: "#fff",
                    boxShadow: 2,
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Grid>

          {logoPreview && logoFile && (
            <Grid item xs={12} sx={{ mt: 3 }}>
              <Button variant="contained" onClick={handleSaveLogo}>
                Save Logo
              </Button>
            </Grid>
          )}
        </Grid>
      </Box>


      {/* SETTINGS PANEL */}
      {showLogoSettings && (
        <Box sx={{ mt: 2 }}>
          <Grid container className="bg bg-white py-4 px-4" sx={{ borderRadius: "16px" }}>

            <Grid item xs={12}>
              <h6 style={{ fontWeight: 600, color: "#7e7e7e" }}>
                Logo Background
              </h6>
            </Grid>

            <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <input
                  type="color"
                  value={logoBgColor}
                  onChange={(e) => setLogoBgColor(e.target.value)}
                  style={{
                    width: "30px",
                    height: "30px",
                    border: "none",
                    cursor: "pointer"
                  }}
                />

                <TextField
                  size="small"
                  value={logoBgColor}
                  onChange={(e) => setLogoBgColor(e.target.value)}
                  fullWidth
                />
              </Box>
            </Grid>

            <Grid item xs={12} sx={{ mt: 3 }}>
              <Button variant="contained" size="small" onClick={handleSaveBgColor}>
                Save
              </Button>
            </Grid>

          </Grid>
        </Box>
      )}
    </>
  );
}
